import { render, staticRenderFns } from "./CreateParameter.vue?vue&type=template&id=c4784302&scoped=true"
import script from "./CreateParameter.vue?vue&type=script&lang=js"
export * from "./CreateParameter.vue?vue&type=script&lang=js"
import style0 from "./CreateParameter.vue?vue&type=style&index=0&id=c4784302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4784302",
  null
  
)

export default component.exports